import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { asyncGetSurveyById } from '../../../../../services/survey.service';
import { Survey } from './props';

export const useSurveyForm = () => {
    const { id } = useParams();
    const [survey, setSurvey] = useState<Survey>();
    const [loading, setLoading] = useState(false);

    const loadSurvey = async () => {
        if (Boolean(id)) {
            setLoading(true);
            try {
                const surveyData: any = await asyncGetSurveyById(id!);
                if (surveyData) {
                    setSurvey(surveyData);
                }
            } finally {
                setLoading(false);
            }
        }
    };

    useEffect(() => {
        loadSurvey();
    }, [id]);

    return {
        survey,
        loading,
        reloadSurvey: loadSurvey,
    };
};
